import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable import/no-internal-modules */
import { DateRangePicker as MuiDateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { MultiInputDateRangeField as MuiMultiInputDateRangeField } from '@mui/x-date-pickers-pro/MultiInputDateRangeField';
import { SingleInputDateRangeField as MuiSingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import * as React from 'react';
import { fromMomentToLocalDate, toMoment, useDateSlotProps } from '../date-picker/utils';
import { TextField } from '../textfield';
import { DESKTOP_MEDIA_QUERY } from '../theme';
import { withVersion } from '../utils';
export const DateRangePicker = withVersion((props) => {
    const { value, minDate, maxDate, singleInput, skeleton, shortcuts, closeOnSelect = false, size = 'small', width = '100%', onChange, ...muiProps } = props;
    const slotProps = useDateSlotProps({
        ...props,
        size,
        width
    });
    if (skeleton) {
        return _jsx(TextField, { width: width, skeleton: true });
    }
    return (_jsx(MuiDateRangePicker, { desktopModeMediaQuery: DESKTOP_MEDIA_QUERY, slots: {
            field: singleInput
                ? MuiSingleInputDateRangeField
                : MultiComponent
        }, ...muiProps, closeOnSelect: closeOnSelect, slotProps: {
            shortcuts: {
                items: shortcuts?.map(({ label, getValue }) => {
                    const range = getValue();
                    const selected = value?.[0] &&
                        range?.[0]?.diff(value?.[0], 'day') === 0 &&
                        value?.[1] &&
                        range?.[1]?.diff(value?.[1], 'day') === 0;
                    return {
                        label,
                        getValue: () => [
                            toMoment.nullable(range?.[0]),
                            toMoment.nullable(range?.[1])
                        ],
                        id: selected ? 'shortcut-selected' : undefined
                    };
                }),
                changeImportance: 'set'
            },
            layout: {
                sx: {
                    '.MuiList-root': {
                        minHeight: '100%',
                        borderRight: '1px solid',
                        borderColor: (theme) => theme.palette.divider,
                        '.MuiListItem-root': {
                            p: 0
                        },
                        '.MuiButtonBase-root': {
                            width: '100%',
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            fontWeight: 'normal',
                            textAlign: 'left',
                            borderRadius: 0,
                            fontSize: 14,
                            p: 0,
                            background: 'transparent',
                            '&:hover': {
                                background: (theme) => theme.palette.primary._states.hover
                            },
                            '&#shortcut-selected': {
                                background: (theme) => theme.palette.primary._states.selected
                            }
                        }
                    }
                }
            },
            ...slotProps.slotProps
        }, sx: { width: '100%', ...muiProps.sx }, value: [
            toMoment.nullable(value?.[0]),
            toMoment.nullable(value?.[1])
        ], minDate: toMoment(minDate), maxDate: toMoment(maxDate), onChange: (date) => {
            onChange?.(fromMomentToLocalDate(date[0]), fromMomentToLocalDate(date[1]));
        } }));
}, '1.0.0');
const MultiComponent = ({ clearable: _clearable, onClear: _onClear, ownerState: _ownerState, ...props }) => _jsx(MuiMultiInputDateRangeField, { ...props });
